"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createIllustration = createIllustration;
var _react = _interopRequireWildcard(require("react"));
var _cdsCommon = require("@cbhq/cds-common");
var _convertDimensionToSize = require("@cbhq/cds-common/utils/convertDimensionToSize");
var _convertSizeWithMultiplier = require("@cbhq/cds-common/utils/convertSizeWithMultiplier");
var _getDefaultSizeObjectForIllustration = require("@cbhq/cds-common/utils/getDefaultSizeObjectForIllustration");
var _cdsUtils = require("@cbhq/cds-utils");
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function createIllustration(variant, config) {
  const defaultSize = (0, _getDefaultSizeObjectForIllustration.getDefaultSizeObjectForIllustration)(variant);
  const Illustration = /*#__PURE__*/(0, _react.memo)(function Illustration({
    name,
    dimension,
    scaleMultiplier,
    testID,
    alt = '',
    fallback = null
  }) {
    const spectrum = (0, _cdsCommon.useSpectrum)();
    const version = config[name];
    const src = `https://static-assets.coinbase.com/ui-infra/illustration/v1/${variant}/svg/${spectrum}/${name}-${version}.svg`;
    const _useMemo = (0, _react.useMemo)(() => {
        let size = defaultSize;
        if (dimension) {
          size = (0, _convertDimensionToSize.convertDimensionToSize)(dimension);
        }
        if (scaleMultiplier) {
          size = (0, _convertSizeWithMultiplier.convertSizeWithMultiplier)(size, scaleMultiplier);
        }
        return size;
      }, [dimension, scaleMultiplier]),
      width = _useMemo.width,
      height = _useMemo.height;
    if (version === undefined) {
      if ((0, _cdsUtils.isDevelopment)()) {
        // eslint-disable-next-line no-console
        console.error(`Unable to find illustration with name: ${name}`);
      }
      return fallback;
    }
    return /*#__PURE__*/_react.default.createElement("img", {
      alt: alt,
      "data-testid": testID,
      height: height,
      src: src,
      width: width
    });
  });
  Illustration.displayName = 'Illustration';
  return Illustration;
}